import { render, staticRenderFns } from "./FavoritesLifecycle.vue?vue&type=template&id=a6e322f8&scoped=true"
import script from "./FavoritesLifecycle.vue?vue&type=script&lang=js"
export * from "./FavoritesLifecycle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e322f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\BabaBello\\bababelloapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6e322f8')) {
      api.createRecord('a6e322f8', component.options)
    } else {
      api.reload('a6e322f8', component.options)
    }
    module.hot.accept("./FavoritesLifecycle.vue?vue&type=template&id=a6e322f8&scoped=true", function () {
      api.rerender('a6e322f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/favorites/FavoritesLifecycle.vue"
export default component.exports